module.exports = __webpack_public_path__ + "static/media/bn.6174f291.png";